/* ============================================================
   Table search
   ------------------------------------------------------------
   One matcher for every "search this table" box, so a row is
   found by anything visible on it rather than by one column.

     const FIELDS = ['employeeCode', 'employeeName', 'emailID'];
     rows.filter((row) => matchesSearch(row, term, FIELDS));

   Values are coerced to strings, so numbers and missing fields
   are safe to list.
   ============================================================ */

export const matchesSearch = (row, term, fields = []) => {
    const query = String(term || "").trim().toLowerCase();
    if (!query) return true;

    return fields.some((field) =>
        String(row?.[field] ?? "").toLowerCase().includes(query));
};

export default matchesSearch;
